import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import Joi from 'joi-full';
import withHandlers from 'recompose/withHandlers';
import compose from 'recompose/compose';
import PayoutForm from '../components/PayoutForm';
import {
  addShopPayout,
  addBarberPayout,
  openCashRegisterDrawer,
  addShopPayin,
  addBarberPayin,
} from '../actions';
import { withActionByRole } from '../../../common/helpers/actions';
import {
  syncValidateData,
} from '../../../common/validator';

const FORM = 'customChargeForm';

const schema = Joi.object().keys({
  amount: Joi.number().min(0).required(),
  desc: Joi.string().optional().allow(null, ''),
});

const validate = values => syncValidateData(values, schema);

const selector = formValueSelector(FORM);

const form = reduxForm({
  form: FORM,
  initialValues: { type: 'payout' },
  validate,
});

const addHandlers = withHandlers({
  save: props => (data) => {
    const updateAction = data.type === 'payout' ? props.addPayout : props.addPayin;

    return updateAction({
      desc: data.desc,
      amount: data.amount,
    }).then(() => {
      props.closePayoutModal();
      return props.openCashRegisterDrawer();
    });
  },
});

const mapDispatchToProps = {
  openCashRegisterDrawer,
};

export default compose(
  connect(state => ({ type: selector(state, 'type') }), mapDispatchToProps),
  withActionByRole('addPayout', addShopPayout, addBarberPayout),
  withActionByRole('addPayin', addShopPayin, addBarberPayin),
  addHandlers,
  form,
)(PayoutForm);
